import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFloor0 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 32,
	viewBox: "0 0 29 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 22.3077,
			width: 29,
			height: 9.66667,
			fill: "var(--rs-theme)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23047,
			y: 25.282,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1543,
			y: 25.282,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0771,
			y: 25.282,
			width: 6.69231,
			height: 6.69231,
			fill: "var(--rs-theme-lighter)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 11.1539,
			width: 29,
			height: 9.66667,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23047,
			y: 14.1283,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1543,
			y: 14.1283,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0771,
			y: 14.1283,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 29,
			height: 9.66667,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.23047,
			y: 2.97437,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1543,
			y: 2.97437,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20.0771,
			y: 2.97437,
			width: 6.69231,
			height: 6.69231,
			fill: "#EDEDED"
		})
	]
});
export default SvgIconFloor0;
